import { SaveRecordAction } from '@aibees/elephant/hooks';
import { SearchTable } from '@aibees/elephant/types';
import { FormDialogConfig } from '@aibees/shared/components';
import { EXPORT_TEMPLATE_MAX_LIMIT } from '@aibees/shared/features/template-management-dialog/constant';
import * as Yup from 'yup';
import { dialogIcon } from '../save-dialog/sx';
import { SearchTableActionDialogNotesConfig } from '../search-table-action-dialog-notes';

const maxLimit = EXPORT_TEMPLATE_MAX_LIMIT;

export const scheme = Yup.object().shape({
  name: Yup.string()
    .required('Name is required')
    .max(100, 'Name must be at most 100 characters'),
  owner: Yup.string(),
  overwriteOwner: Yup.boolean(),
  selectOwner: Yup.boolean(),
  [SaveRecordAction.CONTACT_ENRICH_EMAIL]: Yup.boolean(),
  [SaveRecordAction.CONTACT_REVERIFY_EMAIL]: Yup.boolean(),
  [SaveRecordAction.BASIC_SAVE]: Yup.boolean(),
  [SaveRecordAction.CONTACT_REVEAL_PROFILE]: Yup.boolean(),
  // [SaveRecordAction.AI_POWERED_ACCOUNT]: Yup.boolean(),
  // [SaveRecordAction.AI_POWERED_CONTACT]: Yup.boolean(),
});

export const config: FormDialogConfig = {
  icon: 'file-download-outline',
  iconSx: dialogIcon,
  submitButtonProps: {
    children: 'Export',
  },
  closeButton: {
    children: 'Cancel',
  },

  scheme,
  defaultValues: {
    selectOwner: true,
    [SaveRecordAction.CONTACT_ENRICH_EMAIL]: true,
    [SaveRecordAction.CONTACT_REVERIFY_EMAIL]: true,
    [SaveRecordAction.CONTACT_REVEAL_PROFILE]: false,
    [SaveRecordAction.BASIC_SAVE]: true,
    [SaveRecordAction.AI_POWERED_ACCOUNT]: true,
    [SaveRecordAction.AI_POWERED_CONTACT]: true,
  },
};

export const noteConfig: Partial<
  Record<SearchTable, SearchTableActionDialogNotesConfig[]>
> = {
  [SearchTable.People]: [
    {
      title: (
        <span>
          Want more than the default columns? Profile Insight unlocks {maxLimit}{' '}
          additional data points — languages, education, skills, and more. Open{' '}
          <b>"Create Template"</b> (or edit an existing one) to select the exact
          fields you need before exporting.
        </span>
      ),
    },
  ],
  [SearchTable.Employees]: [
    {
      title:
        'No charges for already enriched/saved data. Our system detects previously enriched/saved info, ensuring you only pay for new services.',
    },
  ],
  [SearchTable.BuyingTeam]: [
    {
      title: '',
    },
  ],
};

export const noteConfigLookalike: Partial<
  Record<SearchTable, SearchTableActionDialogNotesConfig[]>
> = {
  [SearchTable.People]: [
    {
      title: (
        <span>
          Want more than the default columns? Profile Insight unlocks {maxLimit}{' '}
          additional data points — languages, education, skills, and more. Open{' '}
          <b>"Create Template"</b> (or edit an existing one) to select the exact
          fields you need before exporting.
        </span>
      ),
    },
  ],
  [SearchTable.Employees]: [
    {
      title:
        'No charges for already enriched/saved data. Our system detects previously enriched/saved info, ensuring you only pay for new services.',
    },
  ],
  [SearchTable.BuyingTeam]: [
    {
      title: '',
    },
  ],
};

export const exportTEmplateNoteConfig: Partial<
  Record<SearchTable, SearchTableActionDialogNotesConfig[]>
> = {
  [SearchTable.People]: [
    {
      title: (
        <span>
          Want more than the default columns? Profile Insight unlocks {maxLimit}{' '}
          additional data points — languages, education, skills, and more. Open{' '}
          <b>"Create Template"</b> (or edit an existing one) to select the exact
          fields you need before exporting.
        </span>
      ),
    },
  ],
  [SearchTable.BuyingTeam]: [
    {
      title: '',
    },
  ],
  [SearchTable.Employees]: [
    {
      title: '',
    },
  ],
};
